import React, { useEffect, useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ConsultaInscricao from './ConsultaInscricao';
import LandingBlog from '../Landing/LandingBlog';
import { trackPageView } from '../../utils/analytics';

type AuthView = 'home' | 'login' | 'register' | 'consulta';

const AuthContainer: React.FC = () => {
  const [currentView, setCurrentView] = useState<AuthView>('home');

  // Track GA4 page_view on SPA view changes
  useEffect(() => {
    const path =
      currentView === 'home' ? '/home' :
      currentView === 'login' ? '/login' :
      currentView === 'register' ? '/register' :
      currentView === 'consulta' ? '/consulta' : `/${currentView}`;

    const titleMap: Record<AuthView, string> = {
      home: 'Início',
      login: 'Login',
      register: 'Cadastro',
      consulta: 'Consulta de Inscrição',
    };

    trackPageView(path, `MCMV - ${titleMap[currentView]}`);
  }, [currentView]);

  const renderCurrentView = () => {
    switch (currentView) {
      case 'home':
        return (
          <LandingBlog
            onShowLogin={() => setCurrentView('login')}
            onShowRegister={() => setCurrentView('register')}
            onShowConsulta={() => setCurrentView('consulta')}
          />
        );
      case 'register':
        return (
          <RegisterForm
            onBackToLogin={() => setCurrentView('login')}
            onShowHome={() => setCurrentView('home')}
            onShowLogin={() => setCurrentView('login')}
            onShowRegister={() => setCurrentView('register')}
            onShowConsulta={() => setCurrentView('consulta')}
          />
        );
      case 'consulta':
        return (
          <ConsultaInscricao
            onBackToLogin={() => setCurrentView('login')}
            onShowHome={() => setCurrentView('home')}
          />
        );
      default:
        return (
          <LoginForm 
            onShowLogin={() => setCurrentView('login')}
            onShowRegister={() => setCurrentView('register')}
            onShowConsulta={() => setCurrentView('consulta')}
            onShowHome={() => setCurrentView('home')}
          />
        );
    }
  };

  return <>{renderCurrentView()}</>;
};

export default AuthContainer;